import Card from "../ui/Card";
import { HEX } from "../../lib/colorSystem";
import SVGAreaChart from "./SVGAreaChart";

// =============================================================================
// DM HEALTH DAILY ACTIVITY — 3-series stacked area chart
// =============================================================================
// Extracted from DMHealthTab Section 3 (left column). Renders the same chart
// in /admin/dm-analytics and /admin/portal — pure render, no callbacks.
// =============================================================================

export interface DMHealthDailyActivityProps {
  chartData: Array<Record<string, unknown>>;
  /** When provided, renders a right-aligned "How metrics work →" link in the header
   *  that opens the DM methodology modal. Omit for display-only surfaces (client portal). */
  onHowItWorks?: () => void;
}

export default function DMHealthDailyActivity({
  chartData,
  onHowItWorks,
}: DMHealthDailyActivityProps) {
  return (
    <Card className="p-4 anim-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="token-14s text-glass-secondary">Daily Activity</h3>
        {onHowItWorks && (
          <button
            onClick={onHowItWorks}
            className="token-11 text-ds-accent hover:opacity-80 transition-opacity"
          >
            How metrics work →
          </button>
        )}
      </div>
      {/* Non-stacked, nested largest→smallest so the funnel reads honestly: of all convos
          CREATED (raw, ManyChat-inflated), how many were real NEW DMs (lead actually replied),
          how many the setter REPLIED to, how many became real CONVERSATIONS. "New Chats" is the
          honest lead-replied count — NOT the raw created total, which is its own faded envelope. */}
      {/* Y axis scales to "New Chats" ONLY (Mako, Aug 10): "for the highest point you're
          going to base it off of the new chats not conversations created". Conversations
          Created is ManyChat-inflated and was setting the scale for all four series,
          which squashed the three he actually reads into a flat line at the floor.
          It still renders, it just no longer gets a vote on the axis. */}
      <SVGAreaChart
        data={chartData}
        xKey="date"
        height={300}
        scaleToKeys={["New Chats"]}
        series={[
          { key: "Conversations Created", color: "#94A3B8", fillOpacity: 0.1 },
          { key: "New Chats", color: HEX.accent, fillOpacity: 0.5 },
          { key: "Replied", color: HEX.green, fillOpacity: 0.28 },
          { key: "Conversations Started", color: HEX.purple, fillOpacity: 0.28 },
        ]}
      />
    </Card>
  );
}
